import { render, staticRenderFns } from "./ramApexRadialChart.vue?vue&type=template&id=08a3e24e&"
import script from "./ramApexRadialChart.vue?vue&type=script&lang=js&"
export * from "./ramApexRadialChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports